import AuthToken from './AuthToken';
import localStorageFacade, { StorageKey } from '../local-store-facade/LocalStoreFacade';

/**
 * Checks the current JWT token's expiration and refreshes it if necessary.
 *
 * The token has a lifespan of 40 minutes. If there is user activity and less than 20 minutes remain before the token expires,
 * this function will request a new token from the server and update it in local storage.
 *
 * @returns A promise that resolves when the refresh process is complete.
 */
export async function refreshToken(): Promise<void> {
  try {
    const token = localStorageFacade.get(StorageKey.AUTH_TOKEN);
    if (!token) return;

    const issuedAt = Number(localStorageFacade.get(StorageKey.AUTH_TOKEN_ISSUED_AT));
    const payload = AuthToken.decodeJWT(token);
    const now = Math.floor(Date.now() / 1000);
    const timeLeft = payload.exp - now;
    const totalTime = payload.exp - issuedAt;

    if (timeLeft <= totalTime / 2) {
      const response = await fetch('/api/refresh-token', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        if (data && data.id_token) {
          localStorageFacade.set(StorageKey.AUTH_TOKEN, data.id_token);
          localStorageFacade.set(StorageKey.AUTH_TOKEN_ISSUED_AT, Math.floor(Date.now() / 1000));
        }
      }
    }
  } catch (error) {
    // Manejo de error opcional
    console.error('Error refreshing token:', error);
  }
}
